import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Lock, Crown, Check } from "lucide-react";

export default function PaywallModal({ open, onClose, title, description, perks = [], onUpgrade }) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="bg-surface border-white/10 rounded-3xl max-w-md p-0 overflow-hidden" data-testid="paywall-modal">
        <DialogTitle className="sr-only">{title}</DialogTitle>
        <DialogDescription className="sr-only">{description}</DialogDescription>
        <div className="relative p-8 text-center">
          <div className="absolute inset-0 bg-brand/10 blur-2xl" />
          <div className="relative z-10">
            <div className="w-16 h-16 rounded-3xl bg-brand mx-auto flex items-center justify-center mb-5 brand-glow">
              <Lock className="w-8 h-8 text-white" />
            </div>
            <h2 className="font-heading text-2xl font-bold tracking-tight">{title}</h2>
            <p className="text-muted-foreground mt-3 leading-relaxed text-sm">{description}</p>
            <div className="mt-6 space-y-2.5 text-left">
              {perks.map((p) => (
                <div key={p} className="flex items-center gap-3 text-sm">
                  <div className="w-5 h-5 rounded-full bg-brand/20 flex items-center justify-center shrink-0">
                    <Check className="w-3 h-3 text-brand" />
                  </div>
                  {p}
                </div>
              ))}
            </div>
            <div className="mt-7 p-4 rounded-2xl bg-white/5 border border-white/10 flex items-baseline justify-center gap-1">
              <span className="font-heading text-3xl font-bold">$19.99</span>
              <span className="text-muted-foreground text-sm">/ month</span>
            </div>
            <Button data-testid="paywall-upgrade-button" onClick={onUpgrade}
              className="w-full h-13 mt-5 h-14 rounded-2xl bg-brand hover:bg-brand-hover text-white font-semibold transition-colors brand-glow">
              <Crown className="w-5 h-5 mr-2" /> Upgrade to Premium
            </Button>
            <p className="text-[11px] text-muted-foreground/60 mt-3">Demo mode — unlocks instantly, no payment.</p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
